import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { COSTAL_COPY, COSTAL_FEATURED_SKU_IDS, COSTAL_RECIPES } from '../constants/costalRecipes';
import './CostalHomePage.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const go = (path) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

const STEPS = [
  {
    n: '01',
    title: 'Elegí lo que hay',
    text: 'Secos, semillas, infusiones y cacao de mesa. Despensa con stock real, no vitrina vacía.',
  },
  {
    n: '02',
    title: 'Armá la receta',
    text: 'Cada receta de comunidad se completa en la tienda. No salís a cazar el ingrediente que falta.',
  },
  {
    n: '03',
    title: 'Pedí la caja',
    text: 'Lista de compra, envío en Colombia. El costal se abre en tu cocina.',
  },
];

const CostalHomePage = () => {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_URL}/products`, { params: { limit: 100 } })
      .then((res) => {
        const list = res.data?.data?.products || res.data?.products || [];
        const items = (Array.isArray(list) ? list : [])
          .filter((p) => COSTAL_FEATURED_SKU_IDS.includes(Number(p.id)))
          .filter((p) => p.status !== 'inactive' && p.status !== 'upcoming')
          .sort(
            (a, b) =>
              COSTAL_FEATURED_SKU_IDS.indexOf(Number(a.id)) -
              COSTAL_FEATURED_SKU_IDS.indexOf(Number(b.id))
          );
        if (!cancelled) setFeatured(items);
      })
      .catch(() => {
        if (!cancelled) setFeatured([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="costal-home">
      <section className="costal-hero">
        <div className="costal-hero-copy">
          <p className="costal-kicker">{COSTAL_COPY.kicker}</p>
          <h1 className="costal-hero-title">
            <span>Come de la tierra.</span>
            <span>Come de despensa.</span>
            <span className="costal-hero-brand">Costal Campesino.</span>
          </h1>
          <p className="costal-hero-lead">
            Secos, semillas, infusiones y cacao de mesa para cocinar y estar bien.
            {` ${COSTAL_COPY.tagline}`}
          </p>
          <div className="costal-hero-actions">
            <button type="button" className="costal-btn costal-btn--solid" onClick={() => go('/tienda')}>
              Ir a la tienda
            </button>
            <button type="button" className="costal-btn costal-btn--ghost" onClick={() => go('/comunidad')}>
              Ver recetas
            </button>
          </div>
        </div>
        <div className="costal-hero-visual" aria-hidden="true">
          <img src="/images/brand/costal-icon.svg" alt="" className="costal-hero-icon" />
          <div className="costal-hero-grain" />
        </div>
      </section>

      <section className="costal-steps">
        <div className="costal-wrap">
          <p className="costal-kicker">De la despensa a tu mesa</p>
          <h2 className="costal-section-title">Cocina real. Caja concreta.</h2>
          <div className="costal-steps-grid">
            {STEPS.map((step) => (
              <article key={step.n} className="costal-step">
                <span className="costal-step-n">{step.n}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="costal-lives">
        <div className="costal-wrap">
          <p className="costal-kicker">Cómo se vive Costal</p>
          <h2 className="costal-section-title">Tres recetas. Una despensa.</h2>
          <div className="costal-lives-grid">
            {COSTAL_RECIPES.map((recipe) => (
              <button
                key={recipe.id}
                type="button"
                className={`costal-live costal-live--${recipe.id}`}
                onClick={() => go('/comunidad')}
              >
                <span className="costal-live-letter">{recipe.letter}</span>
                <span className="costal-live-kicker">{recipe.kicker}</span>
                <strong>{recipe.name}</strong>
                <span className="costal-live-lead">{recipe.lead}</span>
                <span className="costal-live-cta">Ver receta</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {featured.length > 0 && (
        <section className="costal-shelf">
          <div className="costal-wrap">
            <div className="costal-shelf-head">
              <div>
                <p className="costal-kicker">Lo que hay en el costal</p>
                <h2 className="costal-section-title">Despensa para esta semana</h2>
              </div>
              <button type="button" className="costal-btn costal-btn--ghost" onClick={() => go('/tienda')}>
                Ver tienda
              </button>
            </div>
            <div className="costal-shelf-row">
              {featured.map((product) => {
                const img =
                  (product.images && product.images[0]) ||
                  product.image ||
                  '/images/placeholders/placeholder.svg';
                const price = Number(product.price);
                const mil = Number.isFinite(price) ? (price >= 1000 ? price / 1000 : price) : null;
                const display = mil != null
                  ? `${mil.toLocaleString('es-CO', { maximumFractionDigits: 1 })} mil`
                  : '';
                return (
                  <button
                    key={product.id}
                    type="button"
                    className="costal-shelf-card"
                    onClick={() => go(`/producto/${product.id}`)}
                  >
                    <span className="costal-shelf-img-wrap">
                      <img
                        src={img}
                        alt=""
                        onError={(e) => {
                          e.currentTarget.src = '/images/placeholders/placeholder.svg';
                        }}
                      />
                    </span>
                    <strong>{product.name}</strong>
                    {display && <span className="costal-shelf-price">{display}</span>}
                  </button>
                );
              })}
            </div>
          </div>
        </section>
      )}

      <section className="costal-band">
        <div className="costal-wrap costal-band-inner">
          <blockquote>
            <p>{COSTAL_COPY.promise}</p>
            <cite>{COSTAL_COPY.tagline}</cite>
          </blockquote>
          <div className="costal-hero-actions">
            <button type="button" className="costal-btn costal-btn--solid" onClick={() => go('/tienda')}>
              Ir a la tienda
            </button>
            <button type="button" className="costal-btn costal-btn--on-dark" onClick={() => go('/comunidad')}>
              Comunidad y recetas
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CostalHomePage;
